<mat-form-field class="w-100" appearance="outline">
    <mat-label>Select Territory</mat-label>
    <mat-select multiple [formControl]="selected_country_territory">
        <mat-option style="display: none;"></mat-option>
        <mat-checkbox (change)="selectAllRegionsTerritory($event)">Select All</mat-checkbox>
        <h6 class="instruction-title">Please select an items from below</h6>
        <ng-container *ngFor="let regions of country_territory_list; index as i">
            <div class="region-group-check">
                <button mat-icon-button (click)="expand(i); false">
                    <mat-icon [ngClass]="{'expandable': regions.expandable}">
                        keyboard_arrow_right
                    </mat-icon>
                </button>
                <mat-checkbox 
                    class="region-checkbox" 
                    [checked]="regions.isSelected"
                    [indeterminate]="checkSomeCompleted(i)"
                    (change)="selectRegions($event, i); false">
                </mat-checkbox>
                <mat-optgroup [label]="regions.region ?? '-'">
                    <div [ngClass]="{'hidden': !regions.expandable}">
                        <mat-option 
                            *ngFor="let countries of regions?.countries; index as j" 
                            [value]="countries.id"
                            (onSelectionChange)="selectIndivisual($event, i, j); false">
                                {{countries.countryName}}
                        </mat-option>
                    </div>
                </mat-optgroup>
            </div>
        </ng-container>
    </mat-select>
</mat-form-field>